import { BadgeDollarSign, ShieldCheck, Lock, PhoneCall, FileText } from "lucide-react";
import { Reveal, SectionHeader } from "../Reveal";
import { CONTACT } from "../../lib/data";

const PROOF = [
    { icon: BadgeDollarSign, title: "TRANSPARENT PRICING", text: "Published per-billboard campaign pricing — $60, $175, $275, and $650 options — with no hidden structure. You see the investment before you ever submit." },
    { icon: Lock, title: "SECURE STRIPE CHECKOUT", text: "Campaign payments are processed through secure Stripe checkout links — your payment details never touch our website." },
    { icon: ShieldCheck, title: "APPROVAL BEFORE GOING LIVE", text: "Every advertisement artwork is reviewed and approved before it goes live. Nothing runs without meeting network requirements." },
    { icon: PhoneCall, title: "A REAL TEAM, A REAL LINE", text: `Talk directly with WealthHaus Media at ${CONTACT.phone} or ${CONTACT.email} — about your quote, your artwork, or your campaign.` },
    { icon: FileText, title: "EVERYTHING IN WRITING", text: "Clear terms & conditions, per-billboard pricing rules, artwork requirements, and an up-front no-refund policy — so you always know exactly how your campaign works." },
];

export const FunnelTrust = () => (
    <section id="trust" className="relative bg-white text-noir py-24 sm:py-32 overflow-hidden" data-testid="funnel-trust">
        <div className="mx-auto max-w-[1200px] px-4 sm:px-6">
            <SectionHeader
                dark={false}
                eyebrow="PROOF & CREDIBILITY"
                title={<>BUILT ON <span className="text-[#A6A6A6]">TRANSPARENCY.</span></>}
                sub="No vague promises — clear pricing, a documented process, and a team you can call directly."
            />
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {PROOF.map((p, i) => (
                    <Reveal key={p.title} delay={i * 0.07} className={`h-full ${i === PROOF.length - 1 ? "sm:col-span-2 lg:col-span-1" : ""}`}>
                        <div className="h-full rounded-2xl border border-zinc-200 bg-white p-7 shadow-[0_14px_44px_rgba(8,7,11,0.07)] transition-all duration-300 hover:border-noir/40 hover:-translate-y-1 hover:shadow-[0_20px_55px_rgba(255,255,255,0.12)]" data-testid={`trust-card-${i}`}>
                            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-noir">
                                <p.icon size={20} className="text-noir" />
                            </span>
                            <h3 className="mt-4 font-alt text-[12px] font-bold tracking-[0.18em] text-noir">{p.title}</h3>
                            <p className="mt-2.5 text-[13px] leading-relaxed text-zinc-600">{p.text}</p>
                        </div>
                    </Reveal>
                ))}
                <Reveal delay={0.35} className="h-full sm:col-span-2 lg:col-span-1">
                    <div className="flex h-full flex-col justify-center rounded-2xl bg-noir p-7 text-white shadow-[0_14px_44px_rgba(8,7,11,0.3)]" data-testid="trust-brand-card">
                        <p className="font-display text-2xl font-extrabold">WEALTHHAUS <span className="text-hotpink">MEDIA</span></p>
                        <p className="mt-1.5 font-alt text-[10px] font-bold tracking-[0.32em] text-zinc-400">PUT YOUR BRAND IN THE SPOTLIGHT™</p>
                        <p className="mt-4 text-[13px] leading-relaxed text-zinc-400">
                            A professional digital billboard and advertising media company — helping businesses put
                            their brand in the spotlight through strategic digital advertising opportunities.
                        </p>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
